<script setup lang="ts">
import FormTipoEvento from '../components/form-tipoevento.vue'
import { useTipoEventoStore } from '../store/useTipoEventoStore'

definePage({
  meta: {
    navActiveLink: 'admin-tipo-evento',
    action: 'edit',
    subject: 'tipo-evento',
  },
})

const store = useTipoEventoStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormTipoEvento is-editing />
</template>
